/** Место подстановки в тексте результата: подставленное значение и границы места в тексте. */
export type ChartTemplatePlace = {
  /** Имя значения выборки, подставленного в это место */
  name: string;
  start: number;
  end: number;
};

/**
 * Место подстановки — имя значения выборки в фигурных скобках.
 *
 * Имя записано так же, как имена колонок выборки: сервер подставляет значение только в такое
 * место, а прочее в скобках оставляет тексту. Пометки повторяемой части под него не подходят и
 * местом подстановки не считаются — значения выборки за ними нет.
 */
const TEMPLATE_PLACE_PATTERN = /\{([A-Za-z_][A-Za-z0-9_]*)\}/g;

/** Места подстановки текста результата — в том порядке, в каком они идут в тексте. */
export const chartTemplatePlaces = (template: string): ChartTemplatePlace[] =>
  [...template.matchAll(TEMPLATE_PLACE_PATTERN)].map((match) => ({
    name: match[1],
    start: match.index ?? 0,
    end: (match.index ?? 0) + match[0].length,
  }));

/** Текст результата с местом подстановки, заменённым на другое значение выборки. */
export const withPlaceValue = (template: string, place: ChartTemplatePlace, name: string): string =>
  `${template.slice(0, place.start)}{${name}}${template.slice(place.end)}`;
